export const fieldTranslations: Record<string, string> = {
  name: "Nom",
  country: "Pays",
  country_name: "Pays",
  sector: "Secteur",
  identification_code: "Code d'identification",
  identification_code_type: "Type de code d'identification",
  issuer_group_id: "Groupe émetteur",
  issuer_group_name: "Groupe émetteur",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
